import {
  VpModal,
  VpModalBody,
  VpModalCloseButton,
  VpModalDialog,
  VpModalFooter,
  VpModalHeader,
} from '@vtmn-play/react';
import { Portal } from '../portal';
import styles from './styles.module.scss';

export type ModalProps = {
  children: React.ReactNode;
  dataTestid: string;
  footer: React.ReactNode;
  isOpen: boolean;
  title: string;
  ariaLabel: string;
  onClose?: () => void;
  closeOnClickOutside?: boolean;
  isClosable?: boolean;
};

export const Modal = ({
  children,
  dataTestid,
  footer,
  isOpen,
  title,
  ariaLabel,
  onClose,
  closeOnClickOutside = true,
  isClosable = true,
}: ModalProps) => {
  return (
    <Portal>
      <VpModal
        data-testid={dataTestid}
        open={isOpen}
        onClose={onClose}
        onOpen={() => console.warn(`Modal opened : ${ariaLabel}`)}
        closeOnClickOutside={closeOnClickOutside}
      >
        <VpModalDialog aria-label={ariaLabel}>
          <div data-testid={dataTestid} />
          <VpModalHeader className={styles['vp-modal-header-custom']}>
            <h2>{title}</h2>
            {isClosable && <VpModalCloseButton aria-label="Close my Modal" />}
          </VpModalHeader>
          <VpModalBody className={styles['vp-modal-body-custom']}>
            {children}
          </VpModalBody>
          <VpModalFooter className={styles['vp-modal-footer-custom']}>
            {footer}
          </VpModalFooter>
        </VpModalDialog>
      </VpModal>
    </Portal>
  );
};
